import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MenuItem } from '../../models/menu-item';

@Component({
  selector: 'app-menu-item-command',
  imports: [],
  templateUrl: './menu-item-command.component.html',
  styleUrls: ['./menu-item-command.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemCommandComponent {
  @Input({ required: true }) public item!: MenuItem;

  public handleCommandClick(): void {
    this.item.command!();
  }
}
